import { HttpErrorResponse } from "@angular/common/http";

import { TPagination } from "@custom-types/sorting";
import { Client } from "@models/client.model";
import { createReducer, on } from "@ngrx/store";

import {
  INTERMEDIARY_ACTION_FAILURE,
  SET_INTERMEDIARY_LIST,
  SET_INTERMEDIARY_LIST_LENGTH,
  SET_INTERMEDIARY_LOADING,
  SET_INTERMEDIARY_PAGINATION,
} from "./intermediary.actions";

export interface IntermediaryState {
  intermediaryLoading: boolean;
  intermediaryList: Array<Client>;
  error: HttpErrorResponse | null;
  pagination: Partial<TPagination> | undefined;
  intermediaryListLength: number;
}

const initialState: IntermediaryState = {
  intermediaryLoading: false,
  intermediaryList: [],
  error: null,
  pagination: undefined,
  intermediaryListLength: -1,
};

export const INTERMEDIARY_REDUCER = createReducer(
  initialState,
  on(INTERMEDIARY_ACTION_FAILURE, (state, action): IntermediaryState => {
    return {
      ...state,
      error: action.error,
    };
  }),

  on(
    SET_INTERMEDIARY_LOADING,
    (
      state: IntermediaryState,
      action: { loading: boolean }
    ): IntermediaryState => {
      return {
        ...state,
        intermediaryLoading: action.loading,
      };
    }
  ),

  on(
    SET_INTERMEDIARY_LIST,
    (
      state: IntermediaryState,
      action: { data: Client[] }
    ): IntermediaryState => {
      return {
        ...state,
        intermediaryList: action.data,
      };
    }
  ),

  on(
    SET_INTERMEDIARY_PAGINATION,
    (
      state: IntermediaryState,
      action: {
        pagination: Partial<TPagination> | undefined;
      }
    ): IntermediaryState => {
      return {
        ...state,
        pagination: action.pagination,
      };
    }
  ),

  on(
    SET_INTERMEDIARY_LIST_LENGTH,
    (
      state: IntermediaryState,
      action: {
        length: number;
      }
    ): IntermediaryState => {
      return {
        ...state,
        intermediaryListLength: action.length,
      };
    }
  )
);
